export default __webpack_public_path__ + "./fonts/closeSession.1def4f5c.svg";